module.exports = __webpack_public_path__ + "img/company.9c04a2a3.jpg";